module.exports = __webpack_public_path__ + "img/mascot-result.d2ae5dcb.png";